import { render } from "./jbedit.vue?vue&type=template&id=2edf2daa&scoped=true"
import script from "./jbedit.vue?vue&type=script&lang=js"
export * from "./jbedit.vue?vue&type=script&lang=js"

import "./jbedit.vue?vue&type=style&index=0&id=2edf2daa&lang=scss&scoped=true"
import "./jbedit.vue?vue&type=style&index=1&id=2edf2daa&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2edf2daa"]])

export default __exports__